import React, { FC } from "react";

interface IProps {
    range: number;
    x: number;
    y: number;
    valid: boolean;
}

const DeviceRange: FC<IProps> = (props) => {
  const {range, x, y, valid} = props;

  return (
    <div
      style={{
        position: "absolute",
        left: x - (range),
        top: y - (range),
        width: `${range*2}px`,
        height: `${range*2}px`,
        backgroundColor: valid ? "green" : "red",
        borderRadius: "50%",
        opacity:  0.5, // 50% transparency
        pointerEvents: "none",
      }}
    />
  );
};

export default DeviceRange;
